import { useCallback } from 'react';
import { ListRenderItem, ListRenderItemInfo, VirtualList, VirtualListProps } from './list';

export type SectionListProps<TItem> = Omit<
  VirtualListProps<string | TItem>,
  'data' | 'renderItem'
> & {
  data: NonNullable<VirtualListProps<string | TItem>['data']>;
  renderItem: ListRenderItem<TItem>;
  renderSectionHeader?: ListRenderItem<string>;
  renderSectionFooter?: ListRenderItem<string>;
};

export function SectionList<TItem>({
  data,
  renderItem: renderItemInput,
  renderSectionHeader,
  ...props
}: SectionListProps<TItem>) {
  const renderItem = useCallback<ListRenderItem<string | TItem>>(
    itemInfo => {
      const { item } = itemInfo;

      if (typeof item === 'string') {
        return renderSectionHeader?.(itemInfo as ListRenderItemInfo<string>) ?? null;
      }

      return renderItemInput(itemInfo as ListRenderItemInfo<TItem>);
    },
    [renderItemInput, renderSectionHeader]
  );

  return <VirtualList data={data} renderItem={renderItem} {...props} getItemType={getItemType} />;
}

const getItemType = (item: any) => (typeof item === 'string' ? 'section' : 'item');
